<template>
  <div>
    <!-- 所有子题目直接显示 -->
    <div class="test-subtests" v-for="(subtest, index) in test.subtests" :key="subtest.id">
      <div class="test-item">
        <!-- 子题目序号和题干 -->
        <div class="subtest-question">
          <span class="subtest-index">{{ index + 1 }}.</span>
          <span class="subtest-title" v-html="convertTestText(subtest.title)" @click="previewImage(subtest.title)"></span>
        </div>
        
        <!-- 单选题 -->
        <single-test
          v-if="subtest.type.base_type === 1"
          :key="'single-' + subtest.id"
          :test="subtest"
          :testId="subtest.id"
          :choiceAnswer="getSubtestAnswer(subtest.id)"
          :tempResult="getSubtestAnswer(subtest.id)"
          @change="handleSubtestAnswerChange(subtest.id, $event)"
          @selectChange="handleSubtestAnswerSelect(subtest.id, $event)">
        </single-test>
        <!-- 多选题 -->
        <multiple-test v-if="subtest.type.base_type === 2" :key="'multiple-' + subtest.id" :test="subtest"
          :testId="subtest.id" :choiceAnswer="getSubtestAnswer(subtest.id)" :tempResult="getSubtestAnswer(subtest.id)"
          :isMultipleType="true" @change="handleSubtestAnswerChange(subtest.id, $event)"
          @selectChange="handleSubtestAnswerSelect(subtest.id, $event)">
        </multiple-test>

        <!-- 判断题 -->
        <check-test v-if="subtest.type.base_type === 3" :key="'check-' + subtest.id" :test="subtest"
          :testId="subtest.id" :choiceAnswer="getSubtestAnswer(subtest.id)" :tempResult="getSubtestAnswer(subtest.id)"
          @change="handleSubtestAnswerChange(subtest.id, $event)"
          @selectChange="handleSubtestAnswerSelect(subtest.id, $event)">
        </check-test>

        <!-- 备选题 -->
        <choice-test v-if="subtest.type.base_type === 4" :key="'choice-' + subtest.id" :test="subtest"
          :testId="subtest.id" :choiceAnswer="getSubtestAnswer(subtest.id)" :tempResult="getSubtestAnswer(subtest.id)"
          @change="handleSubtestAnswerChange(subtest.id, $event)"
          @selectChange="handleSubtestAnswerSelect(subtest.id, $event)">
        </choice-test>

        <!-- 简答题 -->
        <shortAnswerTest v-if="subtest.type.base_type === 5" :key="'short-' + subtest.id"
          :choiceAnswer="getSubtestAnswer(subtest.id)" :tempResult="getSubtestAnswer(subtest.id)" :testId="subtest.id"
          @change="handleSubtestAnswerChange(subtest.id, $event)"
          @selectChange="handleSubtestAnswerSelect(subtest.id, $event)">
        </shortAnswerTest>

        <!-- 不定项选择题 (同单选题) -->
        <single-test v-if="subtest.type.base_type === 6" :key="'indeterminate-' + subtest.id" :test="subtest"
          :testId="subtest.id" :choiceAnswer="getSubtestAnswer(subtest.id)" :tempResult="getSubtestAnswer(subtest.id)"
          @change="handleSubtestAnswerChange(subtest.id, $event)"
          @selectChange="handleSubtestAnswerSelect(subtest.id, $event)">
        </single-test>
      </div>
    </div>
    <!-- 统一答案解析 -->
    <answer v-if="showAnswer" :test="test"></answer>
  </div>
</template>

<script>
import singleTest from '@/components/test/single-test.vue'; // 单选题
import multipleTest from '@/components/test/multiple-test.vue'; // 多选题
import checkTest from '@/components/test/check-test.vue'; // 判断题
import choiceTest from '@/components/test/choice-test.vue'; // 备选题
import shortAnswerTest from '@/components/test/short-answer-test.vue'; // 简答题
import answer from '@/components/test/answer.vue'; // 答案解析

export default {
  name: 'comprehensive-test',
  components: {
    singleTest,
    multipleTest,
    checkTest,
    choiceTest,
    shortAnswerTest,
    answer,
  },
  props: {
    test: {
      type: Object,
      default: () => ({}),
    },
    testId: {
      type: Number,
      default: null,
    },
    choiceAnswer: {
      type: [String, Object],
      default: '',
    },
    tempResult: {
      type: [String, Object],
      default: '',
    },
    showAnswer: { // 是否显示答案
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      subtestAnswers: {},
    };
  },
  computed: {
    // 解析传入的答案
    parsedAnswers() {
      if (this.tempResult && typeof this.tempResult === 'string') {
        try {
          return JSON.parse(this.tempResult);
        } catch (e) {
          return {};
        }
      }
      if (this.choiceAnswer && typeof this.choiceAnswer === 'string') {
        try {
          return JSON.parse(this.choiceAnswer);
        } catch (e) {
          return {};
        }
      }
      if (typeof this.tempResult === 'object') {
        return this.tempResult;
      }
      if (typeof this.choiceAnswer === 'object') {
        return this.choiceAnswer;
      }
      return {};
    },
  },
  watch: {
    parsedAnswers: {
      handler(newVal) {
        if (newVal) {
          this.subtestAnswers = { ...newVal };
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    previewImage(e) {
      this.$emit('previewImage', e);
    },

    // 获取子题目的答案
    getSubtestAnswer(subtestId) {
      return this.subtestAnswers[subtestId] || '';
    },

    // 保存子题目的答案
    handleSubtestAnswerChange(subtestId, answer) {
      this.subtestAnswers[subtestId] = answer;
      this.$emit('change', JSON.stringify(this.subtestAnswers));
    },

    // 实时保存选择
    handleSubtestAnswerSelect(subtestId, answer) {
      this.subtestAnswers[subtestId] = answer;
      this.$emit('selectChange', JSON.stringify(this.subtestAnswers));
    },



    change(e) {
      this.$emit('change', e);
    },

    selectChange(result) {
      this.$emit('selectChange', result);
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}

.test-subtests {
  padding: 0 20px;
  margin-bottom: 20px;
}

.test-item {
  margin-bottom: 30px;
}

.subtest-question {
  margin-bottom: 10px;
  line-height: 1.6;
}

.subtest-index {
  font-weight: bold;
  font-size: 20px;
  color: #333;
  margin-right: 5px;
}

.subtest-title {
  font-size: 20px;
  color: #333;
}
</style>
